module.exports = __webpack_public_path__ + "img/banner_ped_v0_red.cce05a5e.png";